import React from 'react';

import { useUser } from '../../context/UserContext';
import {
  createIcimLogoutURL,
  logOutUser,
} from '../../helpers/api/user-profile-api';
import { getLocale } from '../../helpers/utils';
import { useGetLibraryConstantsDictionary } from '../../hooks/use-get-library-constants-dictionary';
import LinkButton from '../ui/link-button/link-button';

interface UserProfileProps {
  user: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
  };
  node_locale: string;
  brandId: string;
}

const UserProfile: React.FC<UserProfileProps> = ({
  user,
  node_locale,
  brandId,
}) => {
  const { setUser } = useUser();

  const dictionary = useGetLibraryConstantsDictionary(node_locale);

  const signOutButtonClickHandler = () => {
    setUser(null);
    logOutUser();
  };

  const createProfileURL = () => {
    const locale = getLocale(node_locale);
    return `${process.env.GATSBY_ICIM_PROFILE_URL}/${brandId?.toLocaleLowerCase()}?ui_locales=${locale}&redirect_uri=${process.env.GATSBY_ICIM_REGISTERED_REDIRECT_URL}`;
  };

  return (
    <div className="max-w-md mx-auto my-12 text-text-default">
      <h2 className="text-headingm font-title lg:text-headingxl mb-6 text-text-default">
        {dictionary?.profile}
      </h2>
      <div className="mb-4">
        <p className="text-bodys">{dictionary?.name}*</p>
        <p className="text-bodyl">{user.firstName}</p>
      </div>
      <div className="mb-4">
        <p className="text-bodys">{dictionary?.surname}*</p>
        <p className="text-bodyl">{user.lastName}</p>
      </div>
      <div className="mb-4">
        <p className="text-bodys">{dictionary?.email}*</p>
        <p className="text-bodyl">{user.email}</p>
      </div>
      <div className="mb-4">
        <p className="text-bodys">{dictionary?.phone}:</p>
        <p className="text-bodyl">{user.phoneNumber}</p>
      </div>
      <LinkButton
        to={createProfileURL()}
        variant="primary"
        size="regular"
        className="mt-8 w-full text-center"
      >
        {dictionary?.editProfile}
      </LinkButton>
      <LinkButton
        to={createIcimLogoutURL()}
        className="mt-8 w-full text-center"
        size="regular"
        variant="secondary"
        onClickHandler={signOutButtonClickHandler}
        isExternalLink
      >
        {dictionary?.signOut}
      </LinkButton>
    </div>
  );
};

export default UserProfile;
